export { P160ClubPage as default } from './P160ClubPage';
